<template>
    <div class="px-2" style="{backgruond-color:white}">
      <!-- search input -->
  
        <div class="d-flex justify-content-center mt-1 headTitle mb-2">Lotes</div>
        <div class="d-flex justify-content-center mt-1 headTitle mb-2">{{fincaName}}</div>
  
  
        <!-- table -->
        <vue-good-table :columns="columns" :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }" 
        
        :sort-options="{
            enabled: true,
        }"

        :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
        >
        <template slot="table-row" slot-scope="props">
  
            <!-- Column: Name -->
            <span v-if="props.column.field === 'sex'" class="text-center">
                <span v-if="props.row.sex===false" class="text-center">M</span>
                <span v-if="props.row.sex===true" class="text-center">H</span>
            </span>
  
            <!-- Column: Status -->
            <span v-else-if="props.column.field === 'status'">
                <b-badge :variant="statusVariant(props.row.status)">
                {{ props.row.status }}
                </b-badge>
            </span>
    
            <!-- Column: Common -->
            <span v-else>
                {{ props.formattedRow[props.column.field] }}
            </span>

            <span v-if="props.column.field === 'action'">
                <b-button class="delete-button" variant="primary" @click="viewLot(props.row.id)">Ver</b-button>
            </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap ">
                    Mostrando 1 de
                    </span>
                    <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                        @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> of {{ props.total }} registros </span>
                </div>
            </div>
        </template>
        </vue-good-table>
        <div class="d-flex  justify-content-end  mt-5  " v-if="!isAdmin()" >
            <span class="dataLog  pt-1 mr-1 mt-5 ">Crear Lote</span>
            <b-button class="bg-primary px-0 pt-0 pb-0 mt-5" style="border-radius:50%">
                <b-link :to="{ name: 'advance-animalbatch' }" style="color:#D7B92C">
                  <feather-icon icon="PlusIcon" size="45" />
                </b-link>
            </b-button>
        </div>
      
        <ControlMenu />
    </div>
</template>
  
  <script>
  import ControlMenu from '@/components/ControlMenu.vue'
  import vSelect from 'vue-select'
  import "vue-select/dist/vue-select.css";
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import PlusButton2 from '@/components/PlusButton2.vue'
  import store from '@/store/index'
  import { Line as LineChartGenerator } from 'vue-chartjs'
  import {Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement } from 'chart.js'
  
  /* ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
  ) */
  
  //let apiURL='https://927d1d30.us-south.apigw.appdomain.cloud/ganapp/api/';
  let self= this;
  export default {
    components: {
      BRow,
      BImg,
      BCol,
      BLink,
      BButton,
      BForm,
      BCardText,
      BCardTitle,
      BFormCheckbox,
      BInputGroup,
      BCardBody,
      BCard,
      VueGoodTable,
      vSelect,
      PlusButton2,
      ValidationProvider,
      ValidationObserver,
      BFormCheckbox,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ControlMenu,
      LineChartGenerator
  
    },
    data() {
      return {
        fincaName:localStorage.getItem('currentFarmName'),
        currentLevelAccess: localStorage.getItem("currentLevelAccess"),
        currAmimal:0,
        pageLength: 25,
        dir: false,
        status1: null,
        status2: null,
        modalShow: false,
        modalCase: 0,
        editShow:false,
        modalTrashShow:false,
        columns: [
          {
              label: 'CODIGO',
              field: 'id',
            },  
          {
              label: 'NOMBRE',
              field: 'name',
            },
            {
              label: 'ANIMALES',
              field: 'animals',
            },
            {
              label: '',
              field: 'action',
            }
        ],
        rows: [],
        animalData:[],
        animal:{
          weight:0,
          age:0,
        },
        weighinsData:[],
        weighins:{
          observations:'',
          animal_id:this.currAmimal,
          weight:0,
          date:''
        },
        searchTerm: '',
      }
    },
    computed: {
      statusVariant() {
        const statusColor = {
          /* eslint-disable key-spacing */
          Current: 'light-primary',
          Professional: 'light-success',
          Rejected: 'light-danger',
          Resigned: 'light-warning',
          Applied: 'light-info',
          /* eslint-enable key-spacing */
        }
  
        return status => statusColor[status]
      },
      direction() {
        if (store.state.appConfig.isRTL) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.dir = true
          return this.dir
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = false
        return this.dir
      },
    },
    methods:{
      isAdmin() {
            return this.currentLevelAccess === "Visualizador";
        },
      async fetchLots(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/lots?farm_id="+farmId, config)
          .then(response => response.json())
          .then(result => {
              console.log(result.lots);
              this.rows = result.lots.map(item => {return {id:item.id,name:item.name,animals:item.animals}});
              console.log(this.rows);
          })
      },

      viewLot(id){
        localStorage.setItem('lodID',id);
        this.$router.push('/advanceHome/Lots/Animals');
      }
    },
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchLots(config);
    },
  }
  </script>
  <style>
  body {
    background-color: white !important;
  }
  table{
      width: 100% !important;
    }
  .subTitle {
    font-weight: 600;
    font-size: 23px;
  
  }
  
  .linkTitle {
  
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #5E8F23;
  
  }
  
  .headTitle {
    font-weight: 600;
    font-size: 24px;
    color: #5E8F23;
  }
  
  thead{
    background-color: #5E8F23;
    text-align:center;
    color:#ffffff;
  }
  thead> tr{
    padding:5px;
  }
  .editAnimal {
    font-weight: 500;
    font-size: 18px;
  }
  
  
  .editModal {
    font-weight: 500;
    font-size: 18px;
  }
  
  span.text-center{
    display:flex;
    justify-content: center;
    text-align: center;
  }
  </style>